import React from 'react';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import {
  IdealMembersInputContainer,
  StyledInput,
  PaperAirplaneButton,
  InputError,
} from './IdealMembersInputWithButton.styles';
import PaperPlane from 'src/images/PaperPlane';

interface IdealMembersInputProps {
  handleIdealMemberSubmit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  inputError?: string;
  idealMember?: string;
  placeholder?: string;
  setIdealMember: (value: string) => void;
  buttonText?: string;
  fontSize?: string;
  hasIcon?: boolean;
  buttonColor?: string;
  buttonBorderColor?: string;
}

const IdealMembersWithButtonInput = ({
  handleIdealMemberSubmit,
  inputError,
  idealMember,
  placeholder,
  setIdealMember,
  buttonText,
  fontSize,
  hasIcon = true,
  buttonColor = palette.accentBlue,
  buttonBorderColor = palette.accentBlue,
}: IdealMembersInputProps): JSX.Element => {
  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleIdealMemberSubmit(event as unknown as React.MouseEvent<HTMLButtonElement, MouseEvent>);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => setIdealMember(event.target.value);

  return (
    <IdealMembersInputContainer className='ideal-members-input-container'>
      <StyledInput
        onChange={handleInputChange}
        type='text'
        name='idealMember'
        value={idealMember}
        maxLength={60}
        placeholder={placeholder}
        onKeyDown={handleInputKeyDown}
        fontSize={fontSize}
      />
      <PaperAirplaneButton
        hasIcon={hasIcon}
        onClick={handleIdealMemberSubmit}
        backgroundColor={buttonColor}
        borderColor={buttonBorderColor}
      >
        <Paragraph
          text={buttonText ?? 'Get Suggestions'}
          color='white'
          standardSize='1'
          weight={700}
          align='center'
        />
        {hasIcon && <PaperPlane width='20px' />}
      </PaperAirplaneButton>
      {inputError && (
        <InputError>
          <Paragraph
            text={inputError}
            standardSize='1'
            size='1rem'
            align='left'
            color={palette.softRed}
            weight='light'
          />
        </InputError>
      )}
    </IdealMembersInputContainer>
  );
};

export default IdealMembersWithButtonInput;
